"use client"

import { useEffect, useState } from "react"

export function useRegistrationStatus() {
  const [enabled, setEnabled] = useState(false)
  const [demoEnabled, setDemoEnabled] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const controller = new AbortController()

    fetch("/api/auth/registration-status", { cache: "no-store", signal: controller.signal })
      .then(async response => {
        const data = await response.json().catch(() => ({}))
        setEnabled(response.ok && data.enabled === true)
        setDemoEnabled(response.ok && data.demo_enabled === true)
      })
      .catch(error => {
        if (error?.name !== "AbortError") {
          setEnabled(false)
          setDemoEnabled(false)
        }
      })
      .finally(() => setLoading(false))

    return () => controller.abort()
  }, [])

  return { enabled, demoEnabled, loading }
}
